// src/components/ExpenseList.js
import React from 'react';

function ExpenseList({ expenses, deleteExpense, editExpense, sortBy, sortOrder, handleSort }) {
  return (
    <div className="table-container">
    <table>
      <thead>
        <tr>
        <th onClick={() => handleSort('date')}>
            日期
            {sortBy === 'date' && (sortOrder === 'asc' ? ' ▲' : ' ▼')}
          </th>
          <th onClick={() => handleSort('amount')}>
            金额
            {sortBy === 'amount' && (sortOrder === 'asc' ? ' ▲' : ' ▼')}
          </th>
          <th>类别</th>
          <th>用户</th>
          <th>备注</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        {expenses.map((expense, index) => {
          // Modify this line to format the date consistently
          const currentDate = new Date(expense.date).toLocaleDateString('zh-CN'); // Use 'zh-CN' for Chinese locale
          const previousDate = index > 0 ? new Date(expenses[index - 1].date).toLocaleDateString('zh-CN') : null;
          // 根据日期是否相同添加不同的样式类
          const rowClass = currentDate !== previousDate ? 'different-date' : '';
          // 根据金额的正负添加不同的样式类
          const amountClass = expense.amount >= 0 ? 'positive-amount' : 'negative-amount';
          return (
            <tr key={expense.id} className={`${amountClass} ${rowClass}`}>
              {/* Use the formatted date here */}
              <td>{currentDate}</td>
              <td>{expense.amount >= 0 ? '+' : ''}{expense.amount}</td>
              <td>{expense.category}</td>
              <td>{expense.user}</td>
              <td>{expense.note}</td>
              <td>
              <button className="edit-btn" onClick={() => editExpense(expense)}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 20h9"></path>
                    <path d="M16.5 3l4.5 4.5-12 12H4v-4l12-12z"></path>
                </svg>
              </button>
              <button className="delete-btn" onClick={() => deleteExpense(expense.id)}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M3 6h18"></path>
                    <path d="M8 6v-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <path d="M5 6v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6"></path>
                </svg>
              </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
  );
}

export default ExpenseList;
